import { WORKOUT_EXERCISE_KEY } from '../../../workout-exercise/model'
import { getValueReduxUtil } from '../../../redux/utils/get-value'
import getCurrentWorkoutExerciseStartWorkoutSelect from '../get-current-workout-exercise'
import { createSelector } from 'reselect'

const getCurrentSetDataStartWorkoutSelect = createSelector(getCurrentWorkoutExerciseStartWorkoutSelect,
  (workoutExercise) => {
    if (!workoutExercise) {
      return
    }
    return getValueReduxUtil(workoutExercise, WORKOUT_EXERCISE_KEY.SET_DATA)
  }
)

export default getCurrentSetDataStartWorkoutSelect
